import {
  GOVGR_BREADCRUMBS__LINK,
  GOVGR_BREADCRUMBS__LIST_ITEM,
} from "../../conf/styles/BreadCrumbs";

const Segment = ({ href, label }) => {
  return (
    <li className={GOVGR_BREADCRUMBS__LIST_ITEM}>
      <a className={GOVGR_BREADCRUMBS__LINK} href={href}>
        {label}
      </a>
    </li>
  );
};

export default Segment;
